
export class CustomerRepresentative {
    public id: number;
    public customerNumberID: number;

    public firstName: string;
    public lastName: string;
    public email: string;
    public cellPhone: string;
    public effectiveDate: any;
    public endDate: any;
    public driverLicenseNumber: string;
    public organizationAdministrator: boolean;
    public mvdNowPassword: any;
    public confirmMVDNowPassword: any;
    public mapExistingUser: boolean;
    public editExistingUser: boolean;
    public deleteExistingUser: boolean;
}
